import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import UiInput from "../../../_uiComponents/UiInput";
import UiSelect from "../../../_uiComponents/common/form/UiSelect";
import {
     UiButton,
     UiToggleButton,
} from "../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../_uiComponents/common/UiInnerSearchWr";
import UiMultipleSelect from "../../../_uiComponents/common/form/UiMultipleSelect";
import Validator from "../../../../_helpers/validate.schema";
import {
     factTableTypesRequest,
     factTableLabelsRequest,
} from "../../../../_redux/_actions";


const validateSchema = () =>
     yup.object().shape({
          // name: yup.string().required("Name is required."),
          // type: yup.string().required("Type is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function FactTableFilterForm(props) {
     const actionDispatch = useDispatch();

     useEffect(() => {
          // actionDispatch(factTableTypesRequest());
          actionDispatch(factTableLabelsRequest());
     }, []);

     const { tableTypes, labels } = useSelector((state) => {
          return {
               tableTypes: state.factTable.types,
               labels: state.factTable.labels,
          };
     });

    
     const submit = async (values) => {
          if (values.typeId) {
               values.typeId = [values.typeId];
          }
          props.getFactTableList({ ...values });
     };

     const clearMultiSelect = () => {};

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               render={({ form, handleSubmit }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <>
                                   <UiInnerSearchWr>
                                        <Grid container spacing={2}>
                                             <Grid item xs={12} lg={9}>
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                            className="sba-search-input"
                                                       >
                                                            <UiInput
                                                                 name="name"
                                                                 type="text"
                                                                 label="Name"
                                                            />
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiMultipleSelect
                                                                 name="labels"
                                                                 label="Labels"
                                                                 options={
                                                                      labels
                                                                 }
                                                                 // value={labels}
                                                                 // setValues={setLebels}
                                                            />
                                                       </Grid>


                                                       {/* <Grid
                                                            item
                                                            xs="12"
                                                            lg="4"
                                                       >
                                                            <UiSelect
                                                                 label="Type"
                                                                 name="typeId"
                                                                 placeholder="Select option"
                                                                 options={tableTypes.map(
                                                                      (
                                                                           type,
                                                                      ) => {
                                                                           return {
                                                                                value: type.id,
                                                                                label: type.name,
                                                                           };
                                                                      },
                                                                 )}
                                                            />
                                                       </Grid> */}
                                                  </Grid>
                                             </Grid>
                                             <Grid item xs={12} lg={3}>
                                                  <Stack
                                                       spacing={2}
                                                       direction="row"
                                                       justifyContent="end"
                                                       sx={{
                                                            width: "100%",
                                                            pt: 0.6,
                                                       }}
                                                  >
                                                       <UiButton
                                                            name="Clear"
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => {
                                                                 form.reset();
                                                                 submit({});
                                                            }}
                                                       />
                                                       <UiButton
                                                            name="Apply"
                                                            variant="contained"
                                                            size="small"
                                                            onClick={
                                                                 handleSubmit
                                                            }
                                                       />
                                                  </Stack>
                                             </Grid>
                                        </Grid>
                                   </UiInnerSearchWr>
                              </>
                         </form>
                    );
               }}
          />
     );
}
